import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCheckedCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 0H1.924A1.935 1.935 0 000 1.924v14.152A1.935 1.935 0 001.924 18h14.152A1.935 1.935 0 0018 16.076V1.924A1.94 1.94 0 0016.05 0zM4.27 8.46a.748.748 0 011.054 0l2.029 2.029a.176.176 0 00.264 0l5.034-5.034a.748.748 0 011.054 0 .748.748 0 010 1.054l-5.93 5.93a.446.446 0 01-.606 0l-2.9-2.925a.748.748 0 010-1.054z",
    fill: "#2355fc"
  })));
}

export { SvgCheckedCheckBox as ReactComponent };
//# sourceMappingURL=CheckedCheckBox.svg.js.map
